import { z } from 'zod'
import { plannerSearchSchema } from '@/features/wedding-plan/components/planner-tabs'

export const receptionSearchSchema = plannerSearchSchema.extend({
  part: z.string().optional().catch(undefined),
})

/** Opens one part on the Pohoštění tab, or the list without `part`. */
export const partSearch = (part: string | undefined) => ({ panel: 'parts', part })
